import React from 'react';
import { Text } from '../../design-system';
import { displayText, formatTime } from '../../helpers/utils';
import Tooltip from '../../components/Tooltip';

interface ProjectTitleProps {
  project: { description?: string; deadline?: string };
}

const ProjectTitle = ({
  project: { description, deadline },
}: ProjectTitleProps) => {
  const { text, more } = displayText(description, 100);
  return (
    <>
      {text}
      {more && <Tooltip text={description}>...</Tooltip>}
      <Text ml={2}>{formatTime(deadline)} </Text>
    </>
  );
};

export default ProjectTitle;
